import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  item: {
    display: "flex",
    marginTop: 4,
    padding: 8,
    borderRadius: 4,
    "&[aria-selected=true]": {
      background: theme.palette.grey[100],
    },
    "&:first-child": {
      marginTop: 0,
    },
  },
  text: {
    flex: 1,
    lineHeight: "16px",
  },
  check: {
    width: 16,
    height: 16,
    fill: theme.palette.primary.main,
    marginRight: 4,
  },
}));
